// extracted by mini-css-extract-plugin
module.exports = {"score-mark":"Menu_score-mark__3aECO","score-s-mark":"Menu_score-s-mark__3r2Ev","menu-item":"Menu_menu-item__3ejSv","active":"Menu_active__1d32I"};